/* eslint-disable react-hooks/exhaustive-deps */
import {
  AlertTost,
  CustomInput,
  CustomModal,
  CustomPhoneInput,
  CustomSelector,
  CustomTable,
  CustomTextArea,
  FilterBar,
  RowAction,
} from "#components";
import { AdminLayout, TableLayout } from "#layouts";
import { addAgronomistDetails } from "#redux/feature/agronomistSlice.js";
import { AdminRoutePath } from "#routes/routePath.jsx";
import { InProgress } from "#UI";
import { containerTypeTableHeader, productTableHeader } from "#utils/seeds.js";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import CustomAlert from "../../components/CustomAlert copy";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { productInitialValues } from "#validations/initialValues.js";
import { productValidationSchema } from "#validations/validationSchema.js";
import QUERY_KEYS from "#services/queryKeys.js";
import ENDPOINTS from "#services/endPoints.js";
import useDelete from "#hooks/useDelete.js";
import usePost from "#hooks/usePost.js";
import usePut from "#hooks/usePut.js";
import useGet from "#hooks/useGet.js";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { numberOnly } from "#utils/helpers.js";
import {
  ContainerTypeModal,
  ContainerUnitModal,
  AddEditProductModal,
  RateUnitModal,
} from "./modals";

const ProductManagement = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [dataCount, setDataCount] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [productDetails, setProductDetails] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [file, setFile] = useState(null);
  const [statusLoadingId, setStatusLoadingId] = useState(null);
  const [containerTypes, setContainerTypes] = useState(["Jug", "Bottle"]);
  const [openContainerModal, setOpenContainerModal] = useState(false);
  const [containerUnits, setContainerUnits] = useState(["Ltr", "Kg"]);
  const [openContainerUnitModal, setOpenContainerUnitModal] = useState(false);
  const [rateUnits, setRateUnits] = useState([]);
  const [openRateUnitModal, setOpenRateUnitModal] = useState(false);


  const [open, setOpen] = useState({
    add: false,
    edit: false,
  });

  const onOpen = (key, id, data) => {
    setOpen({ ...open, [key]: true });
    setProductDetails(data);
  };

  const onClose = (key) => {
    setOpen({
      ...open,
      [key]: false,
    });
    setProductDetails(null);
    resetForm();
  };

  const {
    data: productListData,
    isLoading: isProductLoading,
    refetch: refetchProductList,
  } = useGet(ENDPOINTS.PRODUCT_LISTING, QUERY_KEYS.PRODUCT_LISTING_QUERY_KEY, {
    page: currentPage.toString(),
    limit: dataCount,
    search: searchInput,
  });

  const {
    mutateAsync: editProductMutateAsync,
    isLoading: isLoadingEditProduct,
  } = usePut(ENDPOINTS.PRODUCT_EDIT, QUERY_KEYS.PRODUCT_EDIT_QUERY_KEY);

  const {
    mutateAsync: statusProductMutateAsync,
    isLoading: isLoadingStatusProduct,
  } = usePut(ENDPOINTS.PRODUCT_STATUS, QUERY_KEYS.PRODUCT_STATUS_QUERY_KEY);

  const { mutateAsync: addProductMutateAsync, isLoading: isLoadingAddProduct } =
    usePost(ENDPOINTS.ADD_PRODUCT, QUERY_KEYS.ADD_PRODUCT_QUERY_KEY);

  const { mutateAsync: deleteProductMutateAsync } = useDelete(
    ENDPOINTS.PRODUCT_DELETE,
    QUERY_KEYS.PRODUCT_DELETE_QUERY_KEY
  );

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: productInitialValues,
    validationSchema: productValidationSchema,
    onSubmit: async (value) => {
      try {
        const data = {
          productId: productDetails?._id,
          name: values?.productName,
          rate: values?.rate,
          rateUnit: values?.rateUnit,
          note: values?.note,
          containerSize: values?.containerSize,
          containerType: values?.containerType,
          containerUnit: values?.containerUnit,
        };
        if (open.add) {
          try {
            const response = await addProductMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("add");
            refetchProductList();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        } else {
          try {
            const response = await editProductMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("edit");
            refetchProductList();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        }
      } catch (error) {
        AlertTost("Something went wrong", "error");
      }
    },
  });

  useEffect(() => {
    if (open.edit) {
      setValues({
        productName: productDetails?.name,
        rate: productDetails?.rate,
        rateUnit: productDetails?.rateUnit || "",
        note: productDetails?.note,
        containerSize: productDetails?.containerSize,
        containerType: productDetails?.containerType,
        containerUnit: productDetails?.containerUnit,
      });
    }
    if (searchInput === "") {
      refetchProductList();
    }
  }, [open.edit, searchInput]);

  // Handle count input change
  const onDataCountChange = (e) => {
    setDataCount(e.target.value);
    setCurrentPage(1);
  };

  //onSearch button
  const onSearchButtonClick = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    refetchProductList();
  };

  //onSearch Change
  const onSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  useEffect(() => {
    refetchProductList();
  }, [dataCount, currentPage]);

  const handleDeleteProduct = async (productId) => {
    CustomAlert({
      title: " Are you sure you  want to delete the product?",
      confirmButtonText: "Confirm",
      icon: "question",
      onConfirm: async () => {
        try {
          await deleteProductMutateAsync({
            productId: productId,
          }).then((response) => {
            AlertTost(response?.message, "success");
            refetchProductList();
          });
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: error?.response?.data?.message,
            icon: "error",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      },
    });
  };

  const handleStatusOnChange = async (item) => {
    try {
      setStatusLoadingId(item._id); // Set loading state for the current row
      await statusProductMutateAsync({
        productId: item?._id,
      });
      await refetchProductList(); // Refresh list after status update
    } catch (error) {
      console.error("Error updating product status:", error);
      // Optionally show a toast or alert
    } finally {
      setStatusLoadingId(null); // Clear loading state
    }
  };
  // Pagination function
  const handelPageChange = (action) => {
    setCurrentPage((prevPage) => prevPage + (action === "prev" ? -1 : 1));
  };

  // drag and drop
  const handleDragOver = (e) => {
    e.preventDefault();
    if (!dragging) setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFile(droppedFile);
    }
  };

  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleRemoveFile = () => {
    setFile(null);
  };
  const containerSizeOptions = [
    "5 L",
    "10 L",
    "20 L",
    "50 L",
    "5 Kg",
    "10 Kg",
  ].map((size, index) => ({
    exterminatorId: index, // unique id for each option
    firstName: size, // we can use firstName to display
    lastName: "", // keep lastName empty
  }));
  const containerTypeOptions = ["jug", "bottle"].map((type, index) => ({
    exterminatorId: index, // unique ID
    firstName: type, // display value
    lastName: "", // keep empty
  }));

  const {
    data: containerTypesData,
    isLoading: isContainerTypesLoading,
    refetch: refetchTypes,
  } = useGet(
    ENDPOINTS.CONTAINER_TYPE_LIST,
    QUERY_KEYS.CONTAINER_TYPE_LIST_QUERY_KEY,
    { limit: 1000000 }
  );

  const {
    data: containerUnitsData,
    isLoading: isContainerUnitsLoading,
    refetch: refetchUnits,
  } = useGet(
    ENDPOINTS.CONTAINER_UNIT_LIST,
    QUERY_KEYS.CONTAINER_UNIT_LIST_QUERY_KEY,
    { limit: 1000000 }
  );

  const {
    data: rateUnitsData,
    isLoading: isRateUnitsLoading,
    refetch: refetchRateUnits,
  } = useGet(
    ENDPOINTS.RATE_UNIT_LIST,
    QUERY_KEYS.RATE_UNIT_LIST_QUERY_KEY,
    { limit: 1000000 }
  );


  useEffect(() => {
    if (containerTypesData?.data) {
      setContainerTypes(containerTypesData.data.map((t) => t.name));
    }
  }, [containerTypesData]);

  useEffect(() => {
    if (containerUnitsData?.data) {
      setContainerUnits(containerUnitsData.data.map((u) => u.name));
    }
  }, [containerUnitsData]);

  useEffect(() => {
    if (rateUnitsData?.data) {
      setRateUnits(rateUnitsData.data.map((u) => u.name));
    }
  }, [rateUnitsData]);


  return (
    <AdminLayout>
      <section className="main-section spacer">
        <div className="container">
          {/* <FilterBar /> */}
          <FilterBar
            onSearchButtonClick={onSearchButtonClick}
            onSearchChange={onSearchChange}
            searchInput={searchInput}
            onChange={onDataCountChange}
            rowLimit={dataCount}
          />
          <div className="table_wrapper_card">
            <div className="row gy-3">
              <div className="col-xl-12">
                <div className="sub-heading flex-box">
                  <h2> Product Listing </h2>
                  <div className="side-content-blk">
                    <button
                      onClick={() => onOpen("add")}
                      className="primary-btn"
                    >
                      Add New Product
                    </button>
                  </div>
                </div>

                <TableLayout
                  tableHeader={productTableHeader}
                  isEmpty={productListData?.data?.list?.length === 0}
                  isLoading={isProductLoading}
                  currentPage={currentPage}
                  totalItems={productListData?.data?.totalItems}
                  onDataCountChange={onDataCountChange}
                  handlePrevPage={() => handelPageChange("prev")}
                  handleNextPage={() => handelPageChange("next")}
                  rowLimit={dataCount}
                >
                  <CustomTable tableHeader={productTableHeader}>
                    {productListData?.data?.list.map((item, index) => {
                      return (
                        <tr key={index} className="cursor-pointer">
                          <td>{item?.name}</td>
                          <td>
                            {item?.rate ? (
                              <>
                                {item?.rate} {item?.rateUnit || ""} /
                                {item?.containerSize || 10}
                                {item?.containerUnit || "Ltr"}{" "}
                                {item?.containerType || "Jug"}
                              </>
                            ) : (
                              "NA"
                            )}
                          </td>
                          <td>
                            <span
                              className={`table-status ${item?.status === "Active"
                                ? "st-active"
                                : "st-suspended"
                                }`}
                            >
                              {item?.status === "Active"
                                ? "Active"
                                : "Inactive"}
                            </span>
                          </td>
                          <RowAction
                            activeAction={{
                              edit: true,
                              view: false,
                              delete: true,
                              status: true,
                            }}
                            onEdit={() => onOpen("edit", item.managerId, item)}
                            onDelete={() => handleDeleteProduct(item._id)}
                            onView={() => {
                              navigation(AdminRoutePath.AGRONOMIST_DETAIL.path);
                              dispatch(addAgronomistDetails(item));
                            }}
                            onStatus={handleStatusOnChange}
                            isLoading={statusLoadingId === item._id}
                            item={item}
                          />
                        </tr>
                      );
                    })}
                  </CustomTable>
                </TableLayout>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  Product modal */}
      <AddEditProductModal
        open={open}
        onClose={onClose}
        handleSubmit={handleSubmit}
        isLoadingAddProduct={isLoadingAddProduct}
        isLoadingEditProduct={isLoadingEditProduct}
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        numberOnly={numberOnly}
        containerUnits={containerUnits}
        setOpenContainerUnitModal={setOpenContainerUnitModal}
        containerTypes={containerTypes}
        setOpenContainerModal={setOpenContainerModal}
        refetchUnits={refetchUnits}
        refetchTypes={refetchTypes}
        isContainerTypesLoading={isContainerTypesLoading}
        isContainerUnitsLoading={isContainerUnitsLoading}
        rateUnits={rateUnits}
        setOpenRateUnitModal={setOpenRateUnitModal}
        refetchRateUnits={refetchRateUnits}
        isRateUnitsLoading={isRateUnitsLoading}

      />
      {/* Container Type Management Modal */}
      <ContainerTypeModal
        open={openContainerModal}
        onClose={() => {
          setOpenContainerModal(false);
          refetchTypes(); // refresh dropdown
        }}
        containerTypes={containerTypes}
        setContainerTypes={setContainerTypes}
      />
      {/* Container Unit Management Modal */}
      <ContainerUnitModal
        open={openContainerUnitModal}
        onClose={() => {
          setOpenContainerUnitModal(false);
          refetchUnits(); // refresh dropdown
        }}
        containerUnits={containerUnits}
        setContainerUnits={setContainerUnits}
      />
      <RateUnitModal
        open={openRateUnitModal}
        onClose={() => {
          setOpenRateUnitModal(false);
          refetchRateUnits();
        }}
      />
    </AdminLayout>
  );
};

export default ProductManagement;
